import inscriptionService from "@/services/inscriptionService";
import haugazelService from "@/services/haugazelService";
import geoService from "@/services/geoService";
import * as moment from 'moment';
import rateService from "@/services/rateService";
import { i18n } from "@/locales/index.js";
import dateRules from "@/validations/dateRules";
import dateSetters from "@/mixins/dateSetters";
import InscriptionService from "@/services/inscriptionService";
import streetService from "@/services/streetService";

const createContract = async (context) => {
  try {
      let response = await inscriptionService.createContract();
      context.commit("setID", response.id);
      // return response.id;
      return response;
  } catch (error) {
    throw error;
  }
};

const setContract = async (context, contract) => {
  context.commit('setID', contract.id);
  if(contract.options.scenario) context.commit('setScenario', contract.options.scenario);

  let energies = 'dual';

  if(!contract.options.has_elec || !contract.options.has_gas) {
    if(!contract.options.has_elec) energies = 'gas';
    if(!contract.options.has_gas) energies = 'elec';
    if(!contract.options.has_elec && !contract.options.has_gas) energies = null; // TO TEST
  }

  context.commit('setEnergies', energies);

  if(contract.address.street) context.commit('setAddressStreet', contract.address.street);
  if(contract.address.number) context.commit('setAddressNumber', contract.address.number);
  if(contract.address.box) context.commit('setAddressBox', contract.address.box);
  if(contract.address.floor) context.commit('setAddressFloor', contract.address.floor);

  if(contract.address.post_code) {
    let locality = {
      zipCode: contract.address.post_code,
      town: contract.address.city
    }

    let geo = await geoService.getProviders(locality.zipCode);
    context.commit("common/setElecProviders", geo.energyProviders.electricity, {root: true});
    context.commit("common/setGasProviders", geo.energyProviders.gas, {root: true});
    locality['region'] = geo.region;
    locality["ident"] = null;
    if (geo.region === 'wl') {
      let zones = await streetService.getWalloniaZone(locality.zipCode);
      let result = zones.candidates ? zones.candidates.find(e => e.city && e.city.ident) : null;
      if (result) {
        locality["ident"] = result.city.ident;
      }
    }

    context.commit('setAddressLocality', locality);
  }

  if(contract.options.inhabitants) context.commit('setInhabitants', contract.options.inhabitants);
  if(contract.options.empty_house) context.commit('setUnoccupied', contract.options.empty_house);
  if(contract.options.is_temporary_offer) context.commit('setUnoccupiedType', contract.options.is_temporary_offer ? 'waiting' : 'soon');
  if(contract.options.is_social_rate) context.commit('setSocialRate', contract.options.is_social_rate);
  if(contract.remark) context.commit('setRemark', contract.remark);

  if(contract.options.has_elec && contract.electricity) {
    if(contract.electricity.ean) context.commit('setElectricityEanKnown', 1);
    if(contract.electricity.ean) context.commit('setElectricityEan', contract.electricity.ean);
    if(contract.electricity.contract_type) context.commit('setElectricityContractType', contract.electricity.contract_type);
    if(contract.electricity.is_green) context.commit('setElectricityGreen', contract.electricity.is_green);
    if(contract.electricity.duration) context.commit('setElectricityDuration', contract.electricity.duration);
    context.commit('setElectricityPreviousProvider', contract.electricity.previous_provider ? contract.electricity.previous_provider.id : context.getters["common/otherElecProviderId"]);
    if(contract.electricity.asap) context.commit('setElectricityAsap', contract.electricity.asap);

    if(contract.electricity.delivery_date) {
      if(dateRules.deliveryDate(moment(contract.electricity.delivery_date))) {
        context.commit('setElectricityDeliveryDate', moment(contract.electricity.delivery_date).format('DD/MM/YYYY'));
      } else {
        // if one is wrong, reset both
        context.commit('setElectricityDeliveryDate', context.dispatch('contract/getDeliveryDate', 'electricity'));
        context.commit('setGasDeliveryDate', context.dispatch('contract/getDeliveryDate', 'gas'));
      }
    }

    if(contract.electricity.meter.status) context.commit('setElectricityMeterStatus', contract.electricity.meter.status);

    if(contract.electricity.move_date) {
      if(contract.electricity.meter.status === 'open') {
        if(dateRules.moveDate(moment(contract.electricity.move_date))) {
          context.commit('setElectricityMoveDate', moment(contract.electricity.move_date).format('DD/MM/YYYY'));
        }
      } else {
        context.commit('setElectricityOpenMeterDate', dateSetters.nextWorkingDay());
      }
    }

    if(contract.electricity.has_solar_panel) context.commit('setElectricitySolarPanel', contract.electricity.has_solar_panel);
    if(contract.electricity.meter.solar_panel_power) context.commit('setElectricitySolarPanelPower', contract.electricity.meter.solar_panel_power);
    if(contract.electricity.meter.solar_panel_number) context.commit('setElectricitySolarPanelNumber', contract.electricity.meter.solar_panel_number);
    if(contract.electricity.meter.has_injection) context.commit('setElectricityMeterInjection', contract.electricity.meter.has_injection);
    let meterType = []
    if (contract.electricity.meter.type) {
      meterType = contract.electricity.meter.type === 'dual' ? ['tou'] : ['mono'];
    }
    if(contract.electricity.meter.has_exclusive) meterType.push('night');
    if(contract.electricity.meter.has_injection){
      meterType.push(contract.electricity.meter.type === 'dual' ? 'injectionTou' : 'injectionBase');
    }

    context.commit('setElectricityMeterType', meterType);
    // context.commit('setElectricityMeterInjection', contract.electricity.has); // Ask John
    if(contract.electricity.meter.number) context.commit('setElectricityMeterNumber', contract.electricity.meter.number);

    if(contract.electricity.meter.reading_type) context.commit('setElectricityMeterReadingType', contract.electricity.meter.reading_type);
    if(contract.electricity.meter.power) context.commit('setElectricityMeterPower', contract.electricity.meter.power);
    if(contract.electricity.index.base) context.commit('setElectricityIndexBase', contract.electricity.index.base);
    if(contract.electricity.index.high) context.commit('setElectricityIndexHigh', contract.electricity.index.high);
    if(contract.electricity.index.low) context.commit('setElectricityIndexLow', contract.electricity.index.low);
    if(contract.electricity.index.exclusive_night) context.commit('setElectricityIndexExclusiveNight', contract.electricity.index.exclusive_night);
    if(contract.electricity.consumption.exclusive_night) context.commit('setElectricityConsumptionExclusiveNight', contract.electricity.consumption.exclusive_night);
    if(contract.electricity.consumption.base) context.commit('setElectricityConsumptionBase', contract.electricity.consumption.base);
    if(contract.electricity.consumption.high) context.commit('setElectricityConsumptionHigh', contract.electricity.consumption.high);
    if(contract.electricity.consumption.low) context.commit('setElectricityConsumptionLow', contract.electricity.consumption.low);
    if(contract.electricity.consumption.injection_base) context.commit('setElectricityInjectionBase', contract.electricity.consumption.injectionBase);
    if(contract.electricity.consumption.injection_high) context.commit('setElectricityInjectionHigh', contract.electricity.consumption.injectionHigh);
    if(contract.electricity.consumption.injection_low) context.commit('setElectricityInjectionLow', contract.electricity.consumption.injectionLow);

    let zipCode;
    if(contract.address.post_code >= 1000 && contract.address.post_code <= 1299){
      zipCode = 'BX';
    } else {
      if((contract.address.post_code >= 1500 && contract.address.post_code <= 3999) || (contract.address.post_code >= 8000 && contract.address.post_code <= 9999))
        zipCode = 'VL';
      else
        zipCode = 'WL';
    }

    let solarPanelScenario = 'PURE_OFFTAKE';
    if(contract.electricity.has_solar_panel){
      if (zipCode === 'BX' || (zipCode === 'VL' && contract.electricity.meter.has_injection == true)) {
        solarPanelScenario = 'COMM_OFFTAKE_AND_INJECTION';
      } else {
        solarPanelScenario = 'COMPENSATED_OFFTAKE';
      }
    }

    if(solarPanelScenario == 'COMM_OFFTAKE_AND_INJECTION' && contract.electricity.consumption.know_net_consumption == false){
      context.dispatch("consumption/recomputeActiveConsumptionValues", false, {root: true});
    }

    context.commit("setElectricitySolarPanelScenario", solarPanelScenario)
  }

  if(contract.options.has_gas && contract.gas) {
    if(contract.gas.ean) context.commit('setGasEanKnown', 1);
    if(contract.gas.ean) context.commit('setGasEan', contract.gas.ean);
    if(contract.gas.contract_type) context.commit('setGasContractType', contract.gas.contract_type);
    if(contract.gas.is_green) context.commit('setGasGreen', contract.gas.is_green);
    if(contract.gas.duration) context.commit('setGasDuration', contract.gas.duration);
    context.commit('setGasPreviousProvider', contract.gas.previous_provider ? contract.gas.previous_provider.id : context.getters["common/otherGasProviderId"]);
    if(contract.gas.asap) context.commit('setGasAsap', contract.gas.asap);

    if(contract.gas.delivery_date) {
      if(dateRules.deliveryDate(moment(contract.gas.delivery_date))) {
        context.commit('setGasDeliveryDate', moment(contract.gas.delivery_date).format('DD/MM/YYYY'));
      } else {
        // if one is wrong, reset both
        context.commit('setGasDeliveryDate', context.dispatch('contract/getDeliveryDate', 'gas'));
        context.commit('setElectricityDeliveryDate', context.dispatch('contract/getDeliveryDate', 'electricity'));
      }
    }

    if(contract.gas.meter.status) context.commit('setGasMeterStatus', contract.gas.meter.status);

    if(contract.gas.move_date) {
      if(contract.gas.meter.status === 'open') {
        if(dateRules.moveDate(moment(contract.gas.move_date))) {
          context.commit('setGasMoveDate', moment(contract.gas.move_date).format('DD/MM/YYYY'));
        }
      } else {
        context.commit('setGasOpenMeterDate', dateSetters.nextWorkingDay());
      }
    }

    if(contract.gas.meter.number) context.commit('setGasMeterNumber', contract.gas.meter.number);
    if(contract.gas.meter.reading_type) context.commit('setGasMeterReadingType', contract.gas.meter.reading_type);
    if(contract.gas.consumption) context.commit('setGasConsumption', contract.gas.consumption);
    if(contract.gas.index)context.commit('setGasIndex', contract.gas.index);
  }

  return true;
}

const setProductWithLead = async (context, lead) => {
  if(lead.megaProductElec || lead.megaProductGas) {
    let elecProduct = null;
    let gasProduct = null;
    let wantGreenProduct = null;

    if(lead.megaProductElec) {
      elecProduct = lead.megaProductElec
    }

    if(lead.megaProductGas) {
      gasProduct = lead.megaProductGas
    }

    if(lead.wantGreenProduct) {
      wantGreenProduct = lead.wantGreenProduct === 1
    } else {
      wantGreenProduct = false;
    }

    if(elecProduct || gasProduct) {
      context.commit('setElectricityProduct', elecProduct);
      context.commit('setGasProduct', gasProduct);
      context.commit('setWantOnlineGreen', wantGreenProduct)

      return 'Offer'
    }
  }

  return 'Consumptions'
}

const setProductWithContract = async (context, contract) => {
  if(contract.electricity || contract.gas) {
    let elecProduct = null;
    let gasProduct = null;

    let product = null;

    if(contract.electricity && contract.electricity.product && contract.electricity.product.id !== 0) {
      product = await haugazelService.getProduct(contract.electricity.product.id, contract.electricity.duration);
      elecProduct = product
      if(elecProduct.pairedProduct) elecProduct['peer'] = elecProduct.pairedProduct.id;
      elecProduct['energyType'] = product.energy
      elecProduct['forced'] = contract.electricity.product.is_forced;
    }

    if(contract.gas && contract.gas.product && contract.gas.product.id !== 0) {
      product = await haugazelService.getProduct(contract.gas.product.id, contract.gas.duration);
      gasProduct = product;
      if(gasProduct.pairedProduct) gasProduct['peer'] = gasProduct.pairedProduct.id;
      gasProduct['energyType'] = product.energy;
      gasProduct['forced'] = contract.gas.product.is_forced;
    }

    if(elecProduct || gasProduct) {
      context.commit('setElectricityProduct', elecProduct);
      context.commit('setGasProduct', gasProduct);

      return 'Offer'
    }
  }

  return 'Consumptions'
}

const getRateCard = async(context, energy) => {
  let language = i18n.locale.toUpperCase();
  let subscription = context.rootState.subscription;
  // let date = subscription.subscriptionDate ? moment(subscription.subscriptionDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
  let date = moment().format('YYYY-MM-DD');
  let zipCode = context.state.address.locality ? context.state.address.locality.zipCode : null;

  let product = context.state[energy].product.productName || context.state[energy].product.hgzCode;

  if(product && zipCode) {
    let response = await rateService.getRateCards(language, zipCode, subscription.customerType,
      energy, date, product, subscription.campaign, subscription.promo);

      return response
  }

  return 0;
}

const getDeliveryDate = async (context, energy) => {
  let product = context.state[energy].product.productName || context.state[energy].product.hgzCode;
  let agent = context.rootState.subscription.agentCustomId
  let campaign = context.rootState.subscription.campaign
  let promo = context.rootState.subscription.promo;

  const deliveryInformation = await InscriptionService.getDeliveryDate({
    product_code: product,
    agent_code: agent,
    campaign_code: campaign,
    promo_code: promo
  })
  const deliveryDate = moment(deliveryInformation.delivery_date, 'YYYY-MM-DD')
  context.commit('setDeliveryDate', deliveryDate);

  context.commit('setInstalmentDaysDD', deliveryInformation.instalment_day_dd);
  context.commit('setInstalmentDaysBT', deliveryInformation.instalment_day_bt.length ? deliveryInformation.instalment_day_bt[0] : 0);

  if (energy === 'electricity') {
    context.commit('setElectricityDeliveryDate', deliveryDate)
  }
  if (energy ===  'gas')  {
    context.commit('setGasDeliveryDate', deliveryDate);
  }
};

const deleteContract = async (context, id) => {
  try {
    let response = await inscriptionService.deleteContract(id);
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  createContract,
  setContract,
  setProductWithLead,
  setProductWithContract,
  getRateCard,
  deleteContract,
  getDeliveryDate
};



// WEBPACK FOOTER //
// ./src/store/modules/contract/actions.js